<template>
  <el-row id="app">

    <div  v-if="load_show">
      <load></load>
    </div>
    <headertop></headertop>
    <el-row class="main">
       <el-row>
        <el-col :span="13">
          <el-form class="videoplay "  ref="video">
            <el-row >
              <el-carousel indicator-position="none"  direction="vertical">
                  <el-carousel-item v-for="(item,recommend_index) in recommend.video_list" :key="recommend_index">
                    <p @click="recommend_click(recommend_index)" :class="recommend_index == recommend.show ? 'recommend1':'recommend2'">{{item.name}}</p>
                  </el-carousel-item>
                </el-carousel>
            </el-row>
            <el-form-item prop="video" style="width: 100%">
              <div class="whole">
                <div class="player-div"  >
                  <el-row :class="video_img_type=='img'? 'video_img1' : 'video_img2'">
                    <img :src="video_img" style="width: 100%;"  />
                  </el-row>
                  <video  ref="videoPlayer" class="video-js video vjs-big-play-centered" controlslist="nodownload noremoteplayback" oncontextmenu = "return false">
                  </video>
                  <div class="player-barrage">
                   <ul class="roll"></ul>
                   <ul class="center"></ul>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11" style="min-height: 12.625rem;">
            <el-tabs v-model="new_tabs.activeName"   @tab-click="handleClick">
               <el-tab-pane v-for="(item,new_tabs_index) in new_tabs.list" :key="new_tabs_index" :label="item.label" :name="item.name" >
                 <!-- <el-row  v-show="item.name=='live'">
                     <el-col >
                        <router-link :to="{name:'Liveintroduce', query: {num:live_info.list.num}}" style="text-align: center;">
                          <img :src="live_info.list.img" style="width: 90%;"  />
                        <el-row  >
                        </el-row>
                        </router-link>
                      </el-col>
                 </el-row> -->
                 <el-row v-show="item.name=='statute'" >
                   <el-row v-if="new_statute_info.list.data.length>0">
                     <el-row  v-for="(item,new_statute_info_index) in new_statute_info.list.data" :key="new_statute_info_index" class="text item" >
                       <el-col :span="21" :offset="1">
                         <div @click="more('fagui',item.file)" >
                           <span style="cursor: pointer;">{{item.name}}</span>
                         </div>
                       </el-col>
                     </el-row>
                     <p v-if="new_statute_info.list.total>5" style="color: red;float: right;cursor: pointer;"  @click="more('fagui','null')">>>>更多</p>
                   </el-row>
                   <el-row v-else style="text-align: center;">
                     <p>暂无法规，敬请期待</p>
                   </el-row>
                 </el-row>
                 <el-row v-show="item.name=='file'" >
                   <el-row v-if="file_list.show_list.length>0" >
                     <el-row v-for="(item,file_list_index) in file_list.show_list" :key="file_list_index" v-if="file_list_index<4" class="text item" >
                       <el-col :span="21" :offset="1">
                         <div @click="more('file','null')">
                           <span style="cursor: pointer;">{{item}}</span>
                         </div>

                       </el-col>
                     </el-row>
                     <p style="color: red;float: right;cursor: pointer"  @click="more('file','null')">>>>更多</p>
                   </el-row>
                   <el-row v-else style="text-align: center;">
                     <p>暂无文档，敬请期待</p>
                   </el-row>
                 </el-row>
                 <el-row v-show="item.name=='new'">
                   <el-card class="box-card right mainright" >
                     <div v-for="(item,noticelist_index) in noticelist.list" :key="noticelist_index" class="text item" style="margin-bottom: 10px;">
                       <a  style="font-size: 0.875rem;letter-spacing: 3px;"  @click="tankgonggao(item)" class="itema"  v-html="item.content" >
                      </a>
                     </div>
                     <p style="color: red;float: right; cursor: pointer;bottom: 0;" @click="noticelist_show()">>>>更多</p>
                   </el-card>
                 </el-row>
               </el-tab-pane>
             </el-tabs>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-row style=" text-align: center;">
            <el-card class="box-card card ">
            <el-col :span="7" :offset='1'  v-for="(item,index) in lesson_map_list" :key="index">
             <router-link   :to="{name:'visitor_coursemap', query: {num:index}}" class="link">
                <img :src="item.img" style="height: 3.125rem;" /></br>
                    <span style="color: black;">{{item.name}}</span>
              </router-link>
            </el-col>

            </el-card>
          </el-row>
        </el-col>
        <el-col :span="11" :offset="2">
          <el-row style="text-align: center;" >
            <el-card class="box-card card ">
            <el-col :span="7" :offset='1'>
              <div @click="show_tishi()">
                <img src="../../assets/home_biji.png" style="height: 3.125rem;" /></br>
                <span style="color: black;">我的笔记</span>
              </div>

            </el-col>
            <el-col :span="7"  :offset='1'>
              <div @click="show_tishi()">
              <img src="../../assets/home_shoucang.png" style="height: 3.125rem;" /></br>
              <span style="color: black;">我的收藏</span>
              </div>
            </el-col>
            <el-col :span="7"  :offset='1'>
              <div @click="show_tishi()">
                <img src="../../assets/home_guankan.png" style="height: 3.125rem;" /></br>
                <span style="color: black;">观看记录</span>
               </div>
            </el-col>
            </el-card>
          </el-row>
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="6" >
          <el-card class="box-card card ">
            <div style="border-bottom: 3px dotted #E6A23C;padding: 0 0 10px 0;" @click="Statistics('allnum')">
              <i class="el-icon-data-analysis i" style="background-color: #E6A23C;float: left;"></i>
              <div  style="margin-left: 5px;float: left;font-size: 0.9375rem;">
                <b>总数：{{videocount.count}}</b><br />
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" >
          <el-card class="box-card card " style="width: 100%;">
             <div style="border-bottom: 3px dotted #409EFF;padding: 0 0 10px 0;" @click="Statistics('ranking')">
                <i class="el-icon-data-analysis i" style="background-color: #409EFF;float: left;"></i>
                <div  style="margin-left: 5px;float: left;font-size: 0.9375rem; ">
                  <b>排名：{{studyorderList.order}}</b><br />
                </div>
              </div>
          </el-card>
        </el-col>
        <el-col :span="6" >
          <el-card class="box-card card" >
            <div style="border-bottom: 3px dotted #67C23A;padding: 0 0 10px 0; " @click="Statistics('time')">
              <i class="el-icon-data-analysis i" style=" float: left;  background-color: #67C23A;"></i>
              <div  style="margin-left: 5px;float: left;font-size: 0.9375rem;">
                <b>时长：{{studyhistory.time}}</b><br />
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" >
          <el-card class="box-card card left" style="width: 100%;">
            <div style="border-bottom: 3px dotted #F56C6C;padding: 0 0 10px 0;" @click="Statistics('tackall')">
              <i class="el-icon-data-analysis i" style="background-color: #F56C6C;float: left;"></i>
              <div  style="margin-left: 5px;float: left;font-size: 0.9375rem;">
                <b>任务：{{traincount}} </b><br />
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-row>
    <footerbom></footerbom>
    <!--最新更多公告弹窗-->
    <el-dialog
      title="最新公告"
      :visible.sync="new_tabs.dialogVisible"
      width="40%"
      >
      <div v-for="(item,noticelist_index) in noticelist.list" :key="noticelist_index" class="text item" style="margin-bottom: 10px;">
        <a  style="font-size: 0.875rem;letter-spacing: 3px;"  @click="tankgonggao(item)" class="itema"  v-html="item.content" >
       </a>
        <p style="margin: 2px;color: #a5a5a5;font-size: 10px;">发布时间：{{item.time}}</p>
      </div>
      <el-pagination background small  :hide-on-single-page="value" :pager-count="5" :page-size='noticelist.per_page' :current-page='noticelist.current_page'
        layout="prev, pager, next" :total='noticelist.total' class="center" style="padding: 0;margin:0;"  @current-change="(val) => handleCurrentChange(val)">
      </el-pagination>
    </el-dialog>
    <!--最新详情公告弹窗-->
    <el-dialog :visible.sync="dialogVisible" >
       <div class="text item" v-html="notice_list.content">
            <!-- <a class="itema"   >
            </a> -->
       </div>
        <p style="margin-top: 10px;color: #a5a5a5;font-size: 10px;">发布时间：{{notice_list.time}}</p>
    </el-dialog>

    <!--统计详情弹窗-->
    <el-dialog :visible.sync="statistics_list.dialogVisible" :title="statistics_list.title">
      <div class="cardbom" v-if="statistics_list.type=='allnum'">
        <el-table
            :data="videocount_list"
            stripe
            style="width: 100%;max-height: calc(100vh - 350px);overflow: auto;">
            <el-table-column
              prop="name"
              label="视频名称"
              min-width="400"
            >
             <template slot-scope="videocount_list">
                <span >{{videocount_list.row.name}}</span>
                <!-- <span @click="videolist(videocount_list.row.num,'0')">{{videocount_list.row.name}}</span> -->
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="cardbom" v-if="statistics_list.type=='ranking'">
        <el-table
            :data="studyorderList_list"
            stripe
            style="width: 100%;height: calc(100vh - 350px);overflow: auto;">
            <el-table-column
              prop="name"
              label="视频名称"
              min-width="400"
            >
             <template slot-scope="studyorderList_list">
                <span>{{studyorderList_list.row.name}}</span>
                <span style="float: right;">{{studyorderList_list.row.time}}</span>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="cardbom" v-if="statistics_list.type=='time'">
        <el-table
            :data="studyhistory_list"
            stripe
            style="width: 100%;max-height: calc(100vh - 350px);overflow: auto;">
            <el-table-column
              prop="name"
              label="视频名称"
              min-width="400"
            >
             <template slot-scope="studyhistory_list">
                <span>{{studyhistory_list.row.name}}</span>
              </template>

            </el-table-column>
          </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="question_dialogVisible" class="question_info">
       <div class="text item" >
            <p v-html="question_info.name" style="color: #FF0000;font-size: 22px;">
            </p>
            <p class="itema" v-html="question_info.answer" style="padding:5px 0px;text-decoration:none;"></p>
            <p style="padding: 10px 0;color: #a5a5a5;font-size: 10px;">发布时间：{{question_info.time}}</p>
       </div>
    </el-dialog>

    <el-dialog
          :title="new_function.title"
          :visible.sync="new_function.dialogVisible"
          width="40%"
          :before-close="handleClose">
          <p  v-html="new_function.list" ></p >
          <el-row style="margin-bottom: 1.25rem;">
            <el-col :span="12">
              <span style="padding: 10px 0;color: #a5a5a5;font-size: 10px;">发布时间：{{new_function.time}}</span>
            </el-col>
            <el-col :span='12'>
              <span style="float: right;color: #E6A23C;cursor: pointer;" @click="new_function_ok('fuwuhao')">我已阅读</span>
            </el-col>
          </el-row>
        </el-dialog>
  </el-row>
</template>

<script>
  import Header from '../../components/index/public/visitor_NavHeader.vue';
  import Footer from '../../components/index/public/NavFooter.vue';
  import load from '../../components/load.vue';
  export default {
    name: 'App',
    data() {
      return {
        all_list:{},
        load_show:false,
        recommend:{
          video_list:[],
           show:0,
           video:[]
        },
        lesson_map_list:[],
        video_img:'',
        video_img_type:'img',
        video_status:false,
        video_name:'',
        file_list:{
          list:[],
          show_list:[]
        },
       player: null,
       videoOptions: {
         lang: 'zh-CN',
         autoplay: true,//自动播放
         controls: true,//用户可以与之交互的控件
         loop:true,//视频一结束就重新开始
         muted:true,//默认情况下将使所有音频静音
         // aspectRatio:"16:9",//显示比率
         // preload:false,//预加载
         notSupportedMessage: '此视频暂无法播放，请稍后再试',
         errorDisplay: false,
         fluid: true,
         controlBar: {
           playToggle:true,
           volumePanel:true,
           currentTimeDisplay:true,
           progressControl:false,
         },
         sources:[{
           src: "",
           type: ""
         }],
       },

        //直播
        live_info:{
          list:[]
        },
        //法规
        new_statute_info:{
          dialogVisible:false,
          list:{
            data:[]
          }
        },
        statistics_list:{
          dialogVisible:false,
          list:[],
          title:"",
          type:''
        },
        new_tabs:{
          list:[
          //   {
          //   label:'正在直播',
          //   name:'live'
          // },
          {
            label:'法规',
            name:'statute'
          },
          {
            label:'文档',
            name:'file'
          },
          {
            label:'最新公告',
            name:'new'
          },
          ],
          activeName:'statute',
          dialogVisible:false
        },
         activeName: 'first',
        video_Solicitation:{
          // dialogVisible:true,
        },
        //服务号弹窗
        new_function:{
          dialogVisible:false,
          list:'',
          url:'../../assets/fuwuhao_erweima.jpg',
          checked:false,
          num:'',
          time:'',
          title:''
        },
        value: false,
        dialogVisible: false,
        question_dialogVisible: false,
        teacherList:[],
        studyorderList:[],
        studyhistory:[],
        traincount:[],
        videocount:[],
        noticelist:[],
        question:[],
        traincount_status:'',
        notice_list:[],//公告详情
        question_info:[],
        anhui_show:false,
       }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      load:load
    },
    mounted: function() {
      this.info()
      this.get_notice('1')
      // this.get_video_hot()
    },
    methods: {
      show_tishi(){
        const h = this.$createElement;
        this.$notify({
          title: '温馨提示',
          message: h('b', { style: 'color: red'}, '更多功能，请联系王老师:13260265598(手机、微信同号)'),
          duration: 0
        })
      },
      info(){
        let _this=this
        _this.axios
        .get("/v2/temp/home_info")
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.all_list=res.data.data
              _this.set_num()
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      get_notice(num){
        let _this = this;
        _this.axios
        .get("/v2/temp/get_notice",
        {params:{page:num,limit:'3'}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.noticelist=res.data.data;
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      set_num(){
        let _this=this
        //总视频
        _this.videocount=_this.all_list.lesson
        _this.videocount_list=_this.all_list.lesson.list;
        // _this.videocount.per_page=parseInt(_this.all_list.videocount.count);
        // //排名
        _this.studyorderList=_this.all_list.order
        _this.studyorderList_list=_this.all_list.order.list
        // //学习记录
        _this.studyhistory=_this.all_list.history
        _this.studyhistory_list=_this.all_list.history.list
        // _this.studyhistory.per_page=parseInt( _this.studyhistory.per_page)

        // //任务总量
        _this.traincount=_this.all_list.train

        // //公告
        // _this.noticelist=res.data.data;
        // _this.noticelist.per_page=parseInt( _this.noticelist.per_page);

        // //法规
        _this.new_statute_info.list=_this.all_list.law

        //文档
        _this.file_list.list=_this.all_list.file
        _this.file_list.show_list=_this.file_list.list

        //地图
        _this.lesson_map_list=_this.all_list.map

        //最新视频
        _this.recommend.video=_this.all_list.hot_video
        _this.video_img=_this.recommend.video[0].img
        for(let i=0;i< _this.recommend.video.length;i++){
          let data={
            name:_this.all_list.hot_video[i].name
          }
          _this.recommend.video_list[i]=data
        }
        // _this.recommend.video=res.data.data
        // _this.get_data()



      },
      get_data(){
         var that = this;
            const nowDate = new Date();
                const date = {
                    // year: nowDate.getFullYear(),
                    month: nowDate.getMonth() + 1,
                    date: nowDate.getDate(),
                }
                const day = date.date>10?date.date:'0'+date.date
                that.get_video_hot_click(day%10)

        },
      recommend_click(index){
        let _this=this
        _this.get_video_hot_click(index)

      },
      start_player(){
            let _this=this
            if(_this.player){
              _this.player.src({type:_this.videoOptions.sources[0].type, src:_this.videoOptions.sources[0].src})
              _this.player.load()
            }else{
              _this.$nextTick(()=>{
                _this.player = _this.$video(_this.$refs.videoPlayer, _this.videoOptions, function onPlayerReady() {

                })
              })
            }
          },
      get_video_hot_play(num){
              let _this=this
              _this.axios.get('/v2/user_resource/get_video_hot',{params: {video:num},}).then(function(res) {
                if(res.status=='200'){
                  if(res.data.code=='1'){
                    _this.video_name=res.data.data.name
                    _this.video_img=res.data.data.img
                    _this.video_img_type='img'
                    _this.videoOptions.sources[0].type=res.data.data.type
                    _this.videoOptions.sources[0].src='/v2/user_resource/play?key='+localStorage.authorization+'&type=0&num='+res.data.data.num
                    setTimeout(() => {
                      _this.video_img_type='video'

                      _this.start_player()
                    },5000)

                  }else{
                    _this.$message.error(res.data.msg)
                  }
                }else{
                  _this.$message.error('服务器内部错误')
                }
              }).catch(function(error) {
                _this.$message.error('服务器内部错误')
              });



              // _this.axios.get('/v2/user_resource/get_video_hot').then(function(res) {
              //   if(res.status=='200'){
              //     if(res.data.code=='1'){
              //
              //     }else{
              //       _this.$message.error(res.data.msg)
              //     }
              //   }else{
              //     _this.$message.error('服务器内部错误')
              //   }
              // }).catch(function(error) {
              //   _this.$message.error('服务器内部错误')
              // });
            },
            get_video_hot(){
              let _this=this
              _this.axios.get('/v2/user_resource/get_video_hot_many').then(function(res) {
                if(res.status=='200'){
                  if(res.data.code=='1'){
                    for(let i=0;i<res.data.data.length;i++){
                      let data={
                        name:res.data.data[i].name
                      }
                      _this.recommend.video_list[i]=data
                    }
                    _this.recommend.video=res.data.data
                    _this.get_data()
                    // _this.get_video_hot_click(0)
                    // _this.video_info(_this.recommend.video[0],0)
                  }else{
                    _this.$message.error(res.data.msg)
                  }
                }else{
                  _this.$message.error('服务器内部错误')
                }
              }).catch(function(error) {
                _this.$message.error('服务器内部错误')
              });
            },
            get_video_hot_click(num){
              this.recommend.show=num
              this.get_video_hot_play(num)
            },
      more(type,num){
        if(type=='file'){
          this.$router.push({path:'/visitor_file'})
        }else{
          if(num=='null'){
            this.$router.push({path:'/visitor_statute_map?num='})
          }else{
            this.$router.push({path:'/visitor_statute_map?num='+num})
          }

        }
      },
      Statistics(type){
        let _this=this
        _this.statistics_list.dialogVisible=true
        _this.statistics_list.type=type
        if(type=='time'){
          _this.statistics_list.title='观看记录'
        }else if(type=='allnum'){
          _this.statistics_list.title='最新视频'

        }else if(type=='ranking'){
          _this.statistics_list.title='我的排名'
        }else{
          this.$router.push({path:'/visitor_tasklist'})
        }
      },
      noticelist_show(){
        let _this=this
        _this.new_tabs.dialogVisible=true
      },
      handleClick(tab, event) {

      },
      new_function_ok(type){
        let _this=this
        var data={
          'num':_this.new_function.num
        }
        if(type=='fuwuhao'){
          _this.axios.post("/v2/user/save_new_notice",{data:data}).then(function (res) {
            if (res.status == "200") {
              if (res.data.code == "1") {
                _this.new_function.dialogVisible=false
              }
            }
          });
        }else{
          // _this.video_Solicitation.dialogVisible=false
        }
      },

      train_notice() {
        const h = this.$createElement;
        this.$notify({
          title: '任务提示',
          message: h('b', { style: 'color: red'}, '您有未完成任务请及时处理'),
          duration: 0
        })
      },
      tankgonggao(item){
        this.dialogVisible=true;
        this.notice_list=item
        this.notice_list.content=item.content.replace(/(<\/?a.*?>)|(<\/?span.*?>)/g, '');
        // this.notice_list.content=item.content.slice(0,a)+item.content.slice((b+1),item.content.length)
      },

      tankquestion(item){
        let _this=this
        _this.axios
        .get("/v2/user_question/get_info",
        {params:{num:item.num}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.question_dialogVisible=true
              _this.question_info=res.data.data
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },


      videolist(num,type){
        this.$router.push({path:'/visitor_courseplay',query:{num: num,type: type,resource:'v'}})
      },

      question_show(){
        this.$router.push({path:'/visitor_question'})
      },

      handleCurrentChange(num){
        this.get_notice(num);
      },



      teacherclick(num){
        this.$router.push({path:'/visitor_TeacherCurriculumList',query:{num:num}})
      },
      handleClose(done) {
        done();
      },
      new_function_handleClose(done){
         this.$message({
            message: '请点击我已阅读完毕，即可',
            type: 'warning'
          });
      },
      // 跳转页面方法
      /* 新标签页*/
      goPage(url) {
        window.open(url, '_blank');
      },
      /* 原页面 */
      // goTo(url) {
      //   this.$router.push(url);
      // }, //高度

    }
  }
</script>

<style scoped>
  .video_img1{
       width: 100%;
       position: absolute;
       z-index: 999;
    }
    .video_img2{
        width: 100%;
       position: absolute;
        z-index: -1;
    }
  .link{
    text-decoration: none;
  }
  .buhuanhang{
     display: inline-block;
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow:ellipsis;
  }
  .main {
    min-height: calc(100vh - 300px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
    overflow: hidden;
  }

  .question_info >>> .el-dialog__body {
      padding: 0px 20px;
  }

  .question_info >>> .el-dialog__header {
      padding: 0px 20px 10px;
  }

  .hide{
     white-space: nowrap;
     overflow: hidden;
     text-overflow: ellipsis;
     display: block;
  }

  .mainleft {
    width: calc(70% - 25px);
    margin-right: 10px;
    margin-top: 10px;
    overflow: hidden;
  }


  .medium {
    width: calc(100% - 40px);
    padding: 20px;
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 20px;
    margin: 0;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .teacon {
    color: white;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /* // 作为弹性伸缩盒子模型显示。 */
    -webkit-line-clamp: 4;
    /* // 显示的行 */
    -webkit-box-orient: vertical;
    /* // 设置伸缩盒子的子元素排列方式--从上到下垂直排列 */
  }

/*  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  } */

  .mainright {

    /* min-height: 1000px; */
  }

  .card {
    margin: 15px 0;
    /* width: calc(50% - 10px); */
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .card div {
    padding-top: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 5px;
  }

  .item {
    margin-bottom: 20px;
  }

  .itema:hover {
    color: #409EFF;
    text-decoration: underline;
    cursor: pointer;
  }

  .el-card__header div {
    text-align: center;

  }
  >>>.el-card__header{
    padding: 0.375rem;
  }
  .cardbom {
    margin: 10px 0;
    padding: 0 10px;
      overflow: hidden;

  }

  .el-pagination {
    width: 100%;
  }

  .i {
    width: 40px;
    height: 40px;
    color: white;
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    border-radius: 5px;
  }

  .anone {
    color: black;
    text-decoration: none;

  }

  .anone:hover {
    color: black;
    text-decoration: none;
  }

  .anone:active {
    color: black;
    text-decoration: none;
  }
  a{
    overflow:hidden;
    	text-overflow:ellipsis;
    	display: -webkit-box;
    	-webkit-box-orient: vertical;
    	-webkit-line-clamp:2;
  }



  /* 视频播放 */
  .videoplay {
    max-width: 100%;
    width: 75%;
  }

  .video {
    display: block;
    height: 100%;
    position: absolute;
  }

  .whole {
    padding-bottom: 56.25%;
    height: 0;
    position: relative;
  }

  .el-form-item {
    padding: 0;
    margin: 0;
  }

  .el-form-item,
  .el-form-item__content,
  .whole,
  .video {
    width: 100%;
  }
  .el-carousel__item p {
      /* color: black; */
      font-size: 15px;
      opacity: 0.75;
      line-height: 2.7rem;
      margin: 0;
      display:-webkit-box;

        text-overflow:ellipsis;

        overflow:hidden;

        -webkit-line-clamp: 1;

        -webkit-box-orient:vertical;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: white;
    }

    .el-carousel__item:nth-child(2n+1) {
      background-color: white;
    }
    >>>.el-carousel__container {
      height: 2.7rem;
      /* height: 500px !important; */
    }
    .recommend1{
      color: blue;
      cursor: pointer;
    }
    .recommend2{
      color: black;
      cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/visitor/Home.vue